module.exports = __webpack_public_path__ + "img/2303.c0eb7fad.jpg";